import { Fragment, useEffect, useState } from 'react';
import { FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

const ItemPublicRange = props => {
    const [checked, setChecked] = useState(false);
    const [indeterminate, setIndeterminate] = useState(false);
    const [listOtherPermission, setListOtherPermission] = useState(props.listDataRoleProjectOther);

    const handleChange = e => {
        let isChecked = true;
        if (indeterminate) {
            setListOtherPermission([])
        }
        if (checked && !indeterminate) {
            isChecked = false;
        }
        setChecked(isChecked);
        setIndeterminate(false);

        if (props?.handleClickCheckedRoleOtherPrj) {
            props?.handleClickCheckedRoleOtherPrj(
                e,
                props.roleId,
                Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.PRJ_OTHER,
                props.selectPermission,
                props.setDataEditPublicRange,
                props.dataEditPublicRange,
                props?.baseProject,
                props.listDataCommon,
                props.setIsChangePublicRange,
                props.listDataRoleProjectOther,
            );
        } else {
            props?.handleClickCheckedRolePublicRange(
                e,
                props.roleId,
                props.groupRole,
                props.selectPermission,
                props.setDataEditPublicRange,
                props.dataEditPublicRange,
                props.listDataCommon,
                props.setIsChangePublicRange,
                props.listDataRoleProjectOther
            );
        }
    };

    useEffect(() => {
        setIndeterminate(props.isCheckRoleOption(props.roleId, listOtherPermission));
        setChecked(props.isCheckRoleOption(props.roleId, props.listDataRoleProject));
    }, []);

    return (
        <>
            <FormGroup
                aria-label="position"
                className={`share-status-range-li popup-list-role ${
                    props.isUseRoleOption(
                        props.roleId,
                        props.listDataRoleProject,
                        listOtherPermission
                    )
                        ? ' share-status-range-li-checked'
                        : ''
                }`}
                id={`share-status-label-all-${props.roleId}-formGroup`}
                onChange={e => handleChange(e)}
                row
            >
                <FormControlLabel
                    value={props.roleId}
                    control={
                        <Checkbox
                            checked={checked}
                            indeterminate={indeterminate}
                            disabled={false}
                            color="secondary"
                            className={'mgr-0'}
                        />
                    }
                    // label={props.roleName}
                    labelPlacement={'end'}
                    id={`share-status-label-all-${props.roleId}`}
                />
                    <OverFlowTooltipWithTabsMui
                        value={props.roleName}
                        className={'label-role'}
                    />
            </FormGroup>
        </>
    );
};

export default ItemPublicRange;
